import { collections } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function Collections() {
  return (
    <section id="collections" className="w-full border-b border-foreground-900/10 bg-background-100">
      <div className="mx-auto w-full max-w-[1360px] px-4 py-16 md:px-8 md:py-24">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            index="01"
            kicker="本期合辑索引"
            title="先挑一本，再从头往下翻"
            description="每一册对应一个被问得最多的方向——封面就是入口，摘要告诉你这册值不值得打开。"
          />
          <a
            href="#index"
            className="hidden cursor-pointer items-center gap-2 whitespace-nowrap text-sm text-primary-700 transition-colors hover:text-primary-600 md:inline-flex"
          >
            查看完整索引
            <span className="flex h-5 w-5 items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </a>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8">
          {collections.map((item) => (
            <article
              key={item.id}
              className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-foreground-900/10 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
            >
              <div className="relative w-full overflow-hidden pt-[133%]">
                <img
                  src={item.cover}
                  alt={`${item.title} 合辑封面`}
                  title={`${item.title} 合辑封面`}
                  className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-accent-500 px-3 py-1 text-[11px] font-medium text-foreground-950">
                  {item.issue}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5 md:p-6">
                <h3 className="font-heading text-lg leading-snug text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">
                  {item.summary}
                </p>
                <div className="mt-5 flex flex-wrap items-center gap-2">
                  {item.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] text-secondary-900"
                    >
                      {tag}
                    </span>
                  ))}
                  <span className="ml-auto whitespace-nowrap text-[11px] text-foreground-500">
                    {item.readTime}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}